import { useTranslation } from 'react-i18next';
import { UpdateChangeDtoStatusEnum } from '@codefluegel/zeta-change-typescript-client';

export const DialogTitle = () => {
  const { t } = useTranslation();

  return {
    revision: t('change.SendChangeRework'),
    reject: t('dialog.reject'),
    accept: t('dialog.AcceptChange'),
    new: t('dialog.createChange'),
    evalComplete: t('dialog.finishEval'),
    evalAccepted: t('dialog.toSendCalc'),
    calcComplete: t('dialog.finishCalc'),
    crWorkpackageInProgress: t('dialog.sendImpl'),
    calcRejected: t('dialog.resendCalc'),
    evalRework: t('dialog.resendKTM'),
    internalApprovalRejected: t('dialog.archive'),
    check: t('dialog.finishImpl'),
    rejectAll: t('dialog.reject'),
    close: t('dialog.closed'),
    discard: t('dialog.discard'),
    ExternalChangeInternallyApproved: t(
      'dialog.ExternalChangeInternallyApproved',
    ),
    CrWorkpackagesInInternalProgress: t(
      'dialog.CrWorkpackagesInInternalProgress',
    ),
  };
};

export const DialogText = () => {
  const { t } = useTranslation();
  return {
    revision: t('dialog.SendBack'),
    reject: t('dialog.RejectChange'),
    accept: t('dialog.attentionEval'),
    new: t('dialog.ChangeToCreated'),
    evalComplete: t('dialog.finishEvalText'),
    evalAccepted: t('dialog.CalcSendText'),
    calcComplete: t('dialog.calcComplete'),
    crWorkpackageInProgress: t('dialog.finalDateSet'),
    CrWorkpackagesInInternalProgress: t(
      'dialog.CrWorkpackagesInInternalProgressText',
    ),
    calcRejected: t('dialog.RejectChange'),
    internalApprovalRejected: t('dialog.archived'),
    evalRework: t('dialog.sendBackKTMText'),
    check: t('dialog.finishImplText'),
    rejectAll: t('dialog.RejectChange'),
    close: t('dialog.closeStatusText'),
    discard: t('dialog.draftDiscardText'),
    ExternalChangeInternallyApproved: t(
      'dialog.ExternalChangeInternallyApprovedText',
    ),
  };
};

export const DialogDateLabel = () => {
  const { t } = useTranslation();
  return {
    accept: t('dates.evalDate'),
    new: t('dates.evalDate'),
    evalComplete: t('dates.evalDate'),
    evalAccepted: t('dates.evalDate'),
    crWorkpackageInProgress: t('dates.implementationDate'),
    CrWorkpackagesInInternalProgress: t('dates.implementationDate'),
  };
};

export const TaskCardLocalizationList = () => {
  const { t } = useTranslation();

  return {
    [UpdateChangeDtoStatusEnum.Draft]: t('status.draft'),
    [UpdateChangeDtoStatusEnum.CrWorkpackagesInProgress]: t(
      'status.toBeImplemented',
    ),
    [UpdateChangeDtoStatusEnum.NewRework]: t('status.newRework'),
    [UpdateChangeDtoStatusEnum.NewRejected]: t('status.new_rejected'),
    [UpdateChangeDtoStatusEnum.InEvaluation]: t('status.evaluationInProgress'),
    [UpdateChangeDtoStatusEnum.EvalAccepted]: t('status.eval_accepted'),
    [UpdateChangeDtoStatusEnum.New]: t('status.new'),
    [UpdateChangeDtoStatusEnum.Rejected]: t('status.rejected'),
    [UpdateChangeDtoStatusEnum.DraftDiscarded]: t('status.draftdiscarded'),
    [UpdateChangeDtoStatusEnum.EvalRework]: t('status.eval_rework'),
    [UpdateChangeDtoStatusEnum.CalcComplete]: t('status.calcFinished'),
    [UpdateChangeDtoStatusEnum.EvalComplete]: t('status.eval_complete'),
    [UpdateChangeDtoStatusEnum.InternalApprovalRejected]: t('status.rejected'),
    [UpdateChangeDtoStatusEnum.Check]: t('status.check'),
    [UpdateChangeDtoStatusEnum.Closed]: t('status.closed'),
    [UpdateChangeDtoStatusEnum.InternalApprovalAccepted]: t(
      'status.internalApprovalAccepted',
    ),
    [UpdateChangeDtoStatusEnum.EvalCalcRejected]: t('status.calcReworkTo'),
    [UpdateChangeDtoStatusEnum.ExternalChangeInternallyApproved]: t(
      'status.ExternalChangeInternallyApproved',
    ),
    [UpdateChangeDtoStatusEnum.CrWorkpackagesInInternalProgress]: t(
      'status.CrWorkpackagesInInternalProgress',
    ),
  };
};
